import { LocationLandingLayout, LocationPageContent } from './LocationLandingLayout'

const content: LocationPageContent = {
  locale: 'tr',
  slug: 'istanbul-bahcelievler-shopify-web-tasarimi',
  meta: {
    title: 'İstanbul Bahçelievler Shopify Web Tasarımı | Thinklyze',
    description:
      'Bahçelievler\'deki işletmeler için profesyonel Shopify mağaza kurulumu, tema özelleştirme ve büyüme optimizasyonu. Hızlı yayına al, hemen satmaya başla.',
    keywords: [
      'Bahçelievler Shopify',
      'Shopify web tasarım Bahçelievler',
      'Shopify mağaza kurulumu İstanbul',
      'Bahçelievler e-ticaret Shopify',
      'Bakırköy Shopify ajansı',
      'istanbul shopify uzmanı',
      'shopify danışmanlık istanbul',
    ],
    canonical: 'https://thinklyze.com/istanbul-bahcelievler-shopify-web-tasarimi',
  },
  hero: {
    badge: 'Bahçelievler Shopify Uzmanı',
    title: 'Bahçelievler\'de Shopify ile Profesyonel E-Ticaret Mağazanızı Kurun',
    subtitle:
      'Shopify mağazanızı en kısa sürede yayına alıyor, satışa hazır hale getiriyoruz. Tema özelleştirmeden ödeme entegrasyonuna, SEO\'dan reklam yönetimine kadar tam kapsamlı Shopify hizmeti.',
    stats: [
      { value: '5 gün', label: 'Ortalama Yayına Alma Süresi' },
      { value: '40+', label: 'Shopify Projesi' },
      { value: '%99', label: 'Müşteri Memnuniyeti' },
    ],
    highlights: [
      {
        title: 'Hızlı Kurulum & Yayın',
        description:
          'Standart kurumsal paketlerde 5 iş gününde Shopify mağazanızı satışa hazır şekilde teslim ediyoruz.',
      },
      {
        title: 'Türkiye\'ye Özel Entegrasyonlar',
        description:
          'İyzico, Param, Papara gibi yerel ödeme sistemleri ve MNG, Aras, Yurtiçi kargo entegrasyonları dahil.',
      },
      {
        title: 'Satış Sonrası Büyüme Desteği',
        description:
          'Mağazanız yayına girdikten sonra da SEO, reklam ve dönüşüm optimizasyonu için yanınızdayız.',
      },
    ],
  },
  problemSolution: {
    title: 'Shopify\'da Karşılaşılan Zorluklar',
    subtitle: 'Yeni başlayanlar ve mevcut Shopify kullanıcılarının en sık yaşadığı sorunlar.',
    items: [
      {
        title: 'Mağazayı kurmak çok zaman alıyor',
        description:
          'Tema seçimi, ürün yükleme, ödeme ayarları ve domain bağlama... Her adımda takılmak zaman ve enerji çalar. Biz tüm teknik kurulumu sizin adınıza yapıyoruz.',
      },
      {
        title: 'Tema güzel görünmüyor, özelleştirmek zor',
        description:
          'Standart Shopify teması işletmenizi yansıtmıyor. Markanıza uygun özel bileşenler ve renk/font sistemiyle Shopify mağazanızı farklılaştırıyoruz.',
      },
      {
        title: 'Ödeme sistemi Türkiye\'ye uygun değil',
        description:
          'Shopify\'ın varsayılan ödeme yöntemleri Türkiye için yeterli değil. İyzico, Param ve yerel bankalar için entegrasyonları sorunsuz yapıyoruz.',
      },
      {
        title: 'Shopify SEO\'su zayıf, organik trafik yok',
        description:
          'Doğru yapılandırılmamış meta başlıklar, yavaş hız ve eksik schema markup organik trafiği engeller. Teknik Shopify SEO optimizasyonuyla bunu düzeltiyoruz.',
      },
    ],
  },
  services: {
    title: 'Bahçelievler için Shopify Hizmetleri',
    items: [
      {
        title: 'Shopify Mağaza Kurulumu',
        description:
          'Sıfırdan Shopify mağaza açma, plan seçimi, domain bağlama ve temel yapılandırma hizmetleri.',
      },
      {
        title: 'Tema Seçimi & Özelleştirme',
        description:
          'Sektörünüze en uygun temayı seçiyor, markanıza göre renk, tipografi ve bileşen özelleştirmeleri yapıyoruz.',
      },
      {
        title: 'Ürün Yükleme & İçerik Optimizasyonu',
        description:
          'Ürün başlıkları, açıklamalar, görseller ve varyantları SEO uyumlu şekilde yapılandırıyoruz.',
      },
      {
        title: 'Ödeme & Kargo Entegrasyonu',
        description:
          'İyzico, Param, Paytr ve yerel kargo firmalarını sorunsuz entegre ediyoruz.',
      },
      {
        title: 'Shopify SEO Optimizasyonu',
        description:
          'Sayfa hızı, meta etiketler, structured data ve iç linkleme yapısıyla organik görünürlük artırma.',
      },
      {
        title: 'Uygulama Entegrasyonu & Otomasyon',
        description:
          'Sadakat programları, e-posta otomasyonu, stok yönetimi ve muhasebe uygulamaları entegrasyonu.',
      },
    ],
  },
  locationBenefits: {
    title: 'Bahçelievler\'de Shopify Uzmanı ile Çalışmanın Avantajları',
    items: [
      {
        title: 'Yüz Yüze Eğitim & Demo',
        description:
          'Shopify panelini nasıl kullanacağınızı, ürün nasıl ekleyeceğinizi yüz yüze öğretiyoruz.',
      },
      {
        title: 'Yerel Ödeme & Lojistik Uzmanlığı',
        description:
          'Türkiye\'ye özgü ödeme ve kargo çözümlerini eksiksiz yapılandırıyoruz.',
      },
      {
        title: 'Hızlı Destek',
        description:
          'Teknik bir sorun çıktığında Bakırköy ofisimizden aynı gün destek sağlayabiliyoruz.',
      },
      {
        title: 'Büyüme Odaklı Yaklaşım',
        description:
          'Mağazayı açmak bitiş değil başlangıç. SEO, reklam ve CRO hizmetleriyle büyümeyi sürdürüyoruz.',
      },
      {
        title: 'Rekabetçi Fiyat',
        description:
          'Büyük Shopify ajanslarının ücretlerinin çok altında, eşit kalitede hizmet alıyorsunuz.',
      },
      {
        title: 'Çok Sektörlü Shopify Deneyimi',
        description:
          'Giyim, kozmetik, ev ürünleri ve gıda gibi birçok kategoride Shopify projesi teslim ettik.',
      },
    ],
  },
  process: {
    title: 'Shopify Kurulum Sürecimiz',
    items: [
      { title: 'Keşif & Brief', description: 'Ürün kategorinizi, hedef kitlenizi ve marka kimliğinizi anlıyoruz.' },
      { title: 'Tema & Tasarım', description: 'En uygun temayı seçiyor, mockup onayladıktan sonra özelleştiriyoruz.' },
      { title: 'Teknik Kurulum', description: 'Ödeme, kargo, SEO ve uygulamaların entegrasyonunu tamamlıyoruz.' },
      { title: 'Yayın & Eğitim', description: 'Mağazayı canlıya alıyor, yönetim panelini kullanmayı öğretiyoruz.' },
    ],
  },
  faqs: [
    {
      question: 'Shopify mağazamı ne kadar sürede kurabiliriz?',
      answer:
        'Standart kurumsal e-ticaret paketleri için 5–7 iş günü yeterlidir. Özel geliştirme veya çok sayıda ürün yüklemesi gereken projelerde 2–3 hafta sürebilir.',
    },
    {
      question: 'Türkiye\'de Shopify kullanmak avantajlı mı?',
      answer:
        'Evet. Shopify\'ın güvenilir altyapısı, hızlı ölçeklenebilirliği ve geniş uygulama ekosistemi Türkiye\'deki e-ticaret işletmeleri için büyük avantaj sağlar. Yerel ödeme entegrasyonlarıyla tam uyumlu çalışır.',
    },
    {
      question: 'Mevcut Shopify mağazamı da geliştiriyor musunuz?',
      answer:
        'Evet. Var olan mağazanızın tasarımını, SEO\'sunu ve dönüşüm oranını iyileştirmek için Shopify denetim paketi sunuyoruz.',
    },
    {
      question: 'Shopify aylık maliyeti ne kadar?',
      answer:
        'Shopify Basic planı aylık ~$39\'dan başlar. Türkiye\'de TL bazlı ödeme imkânı da mevcut. Plan seçiminde işletme büyüklüğünüze göre size en uygun seçeneği öneriyoruz.',
    },
  ],
  cta: {
    badge: 'Bahçelievler Shopify Uzmanı',
    title: 'Shopify Mağazanızı 5 Günde Yayına Alalım',
    description:
      'Ücretsiz Shopify danışmanlık görüşmesi için bugün randevu alın. İşletmenize en uygun planı, tahmini maliyeti ve yayına alma takvimini birlikte netleştirelim.',
  },
  areaServed: ['Bahçelievler', 'Bakırköy', 'Bağcılar', 'Küçükçekmece', 'İstanbul', 'İstanbul Avrupa Yakası'],
  coordinates: { latitude: 41.0016, longitude: 28.8776 },
  address: {
    streetAddress: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
    addressLocality: 'Bakırköy',
    addressRegion: 'İstanbul',
    postalCode: '34140',
    addressCountry: 'TR',
  },
  relatedServices: {
    title: 'İlgili Hizmetlerimiz',
    items: [
      { name: 'Shopify Danışmanlığı', href: '/shopify', description: 'Mevcut Shopify mağazanızı büyütün.' },
      { name: 'SEO & GEO Optimizasyon', href: '/services/seo-geo', description: 'Shopify mağazanıza organik trafik çekin.' },
      { name: 'Google Ads', href: '/services/google-ads', description: 'Shopify için Shopping kampanyaları.' },
      { name: 'Web Tasarım', href: '/services/web-design', description: 'Özel e-ticaret tasarımı.' },
    ],
  },
}

const IstanbulBahcelievlerShopify = () => {
  return <LocationLandingLayout content={content} />
}

export default IstanbulBahcelievlerShopify
